
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 2.25a.75.75 0 01.75.75v1.286a7.752 7.752 0 016.964 6.964H21a.75.75 0 010 1.5h-1.286a7.752 7.752 0 01-6.964 6.964V21a.75.75 0 01-1.5 0v-1.286a7.752 7.752 0 01-6.964-6.964H3a.75.75 0 010-1.5h1.286a7.752 7.752 0 016.964-6.964V3a.75.75 0 01.75-.75zM5.75 12a6.25 6.25 0 1012.5 0 6.25 6.25 0 00-12.5 0zM12 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"}})])
          )
        }
      }
    